import { HttpClient } from '@angular/common/http';
import {
    Component,
    OnInit,
    Inject,
    ViewChild,
    Output,
    EventEmitter,
    Input,
} from '@angular/core';
import { map, forkJoin, Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe, DOCUMENT } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BackendListModel } from 'src/app/models/common/list.model';
import { DomainCodeApiService } from 'src/app/services/domain_code/domain-code-api.service';
import { DomainCode } from 'src/app/models/common/model';
import { ContainerMasterApiService } from 'src/app/services/domain_code/container-master-api.service';
import { ContainerSizeType } from 'src/app/models/container_master_model/sizeType';
import { CurrencyMasterApiService } from 'src/app/services/domain_code/currency-master-api.service';
import { CurrencyModel } from 'src/app/models/currency_master_model/currency';
import { LocationApiService } from 'src/app/services/domain_code/location-api.service';
import { LocationModel } from 'src/app/models/container_master_model/location';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DocumentModel } from 'src/app/models/document';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { DepotMasterApiService } from 'src/app/services/domain_code/depot-master-api.service';
import { MatAccordion } from '@angular/material/expansion';
import { OperationalCharges } from 'src/app/models/Depot_Master_Model/operational-charges';
import { Locationport } from 'src/app/models/Depot_Master_Model/locationport';
import { Locationdocuments } from 'src/app/models/Depot_Master_Model/locationdocuments';
import { DepotMasterTab2 } from 'src/app/models/depot-master-model';
import { Slab } from 'src/app/models/Depot_Master_Model/slab';
import { DepotMasterTab1 } from 'src/app/models/Depot_Master_Model/depot-master-tab1';
import { WarningBoxComponent } from '../../dialog-box/warning-box/warning-box.component';
import { ContactsModel } from 'src/app/models/contacts';
import { LocationConnectivityModel } from 'src/app/models/location-connectivity-model';
import { MatTableDataSource } from '@angular/material/table';
import { ManHourCharge } from 'src/app/models/Depot_Master_Model/man-hour-charge';
import { StorageCharge } from 'src/app/models/Depot_Master_Model/storage-charge';
import { Container } from 'src/app/models/Depot_Master_Model/container';
import { ContainerSize } from 'src/app/models/Depot_Master_Model/container-size';
import { Charge } from 'src/app/models/Depot_Master_Model/charge';
import { Depotcontainertypegroup } from 'src/app/models/Depot_Master_Model/depotcontainertypegroup';
import { identifierName } from '@angular/compiler';
import { DocumentApiService } from 'src/app/services/domain_code/document-api.service';
import { param } from 'jquery';
import { EmbassyService } from 'src/app/services/embassy.service';
import { Sort } from '@angular/material/sort';

@Component({
    selector: 'app-depot-stepper',
    templateUrl: './custom-stepper.component.html',
    styleUrls: ['./custom-stepper.component.scss'],
})


export class DepotStepperComponent implements OnInit {
    pageLength = 0;
    pageSize = 10;
    pageIndex = 0;
    currencyUrl = `${ApiRoutes.CurrencyMaster}currency/?currency_code=::search::`;
    location_Url = `http://10.10.1.100:8000/api/depot_master/location_connectivity_master/?name=::search::`

    @Input()
    isEditable: boolean = true;
    @Input()
    errorObj: any = {};
    @Input()
    loader: boolean = true;
    @ViewChild(MatAccordion) accordion!: MatAccordion;
    @Output("back") back: EventEmitter<any> = new EventEmitter();
    @Output("addNew") addNew: EventEmitter<any> = new EventEmitter();

    @Output()
    closeForm = new EventEmitter<DepotMasterTab1>();
    @Output()
    isEditableChange = new EventEmitter<boolean>();
    @Output()
    currencyChange = new EventEmitter<string>();
    @Output()
    refreshDepot = new EventEmitter<string>();
    refreshTable = new Subject();
    wasedit: boolean;
    isDisabled: boolean = false;
    defaultErrorObj: any = {};
    fileToUpload: any;
    imageUrl: any;
    depotImg: string = 'assets/images/products/depot.png';
    globalCurrency: any;
    COLUMNS_SCHEMA = [
        {
            key: 'container_type_group',
            type: 'select',
            label: 'Container Type Group',
        },
        {
            key: 'container_size',
            type: 'select',
            label: 'Container Size',

        },
        {
            key: 'charge',
            type: 'select',
            label: 'Charge Rate',

        },

        {
            key: 'charge_rate',
            type: 'text',
            label: 'Charge',
        },

        {
            key: 'isEdit',
            type: 'isEdit',
            label: 'Actions',
        },
    ];
    COLUMNS_SCHEMA1 = [
        {
            key: 'document_type',
            type: 'text',
            label: 'Document Type',
        },
        {
            key: 'effective_from_date',
            type: 'text',
            label: 'Effective From Date',
        },
        // {
        //     key: 'effective_to_date',
        //     type: 'text',
        //     label: 'Effective To Date',
        // },
        {
            key: 'created_by',
            type: 'text',
            label: 'Uploaded By',
        },

        {
            key: 'document',
            type: 'text',
            label: 'Document',
        },

        {
            key: 'isEdit',
            type: 'isEdit',
            label: '',
        },
    ];
    displayedColumns: string[] = this.COLUMNS_SCHEMA.map((col) => col.key);

    columnsSchema: any = this.COLUMNS_SCHEMA;
    columnsSchema1: any = this.COLUMNS_SCHEMA1;
    displayedColumns1: string[] = ['document', 'document_type', 'effective_from_date', 'created_by', 'isEdit'];
    counter: number = 0;
    counter1: number = 0;
    rows = [];
    // _contacts = [];
    _documents = [];
    _manhourcharge: any;
    _storagecharge: any;
    isWeekendOpen = false;
    isEdiOpen = false;
    isPrime = false;
    isSubmitted = false;
    isToggler = false;
    isshowDoc: boolean;
    isshowCmplt: boolean;
    isshowBulk: boolean;
    isShow: boolean;
    showEdi: boolean = false;
    showWeekoff: boolean = false;
    savedBasic: boolean = false;
    savedPort: boolean = true;
    isShownPort: boolean = true;
    isWeekoffs: boolean = false;
    editRowId;
    _ListOpeartionalCharge = []
    loggedInUser;
    // urls
    base_url = ApiRoutes.DepotMaster;
    country_url = ApiRoutes.Geo;

    isAddOpChargeDisabled: boolean = false;
    depotOptionalChargeList: any; // List of optional charges to display in dropdown.
    selectedDepotOptionalCharge: any; // To store selected optional charge in this variable
    operationalChargeTable; // Define Table columns and rows
    operationalChargeDisplayColumns = [];
    operationalChargeData; // Never use anywhere else, data will be assigned only once
    opChargeCurrency = [];
    col_order = [];
    _contacts: MatTableDataSource<ContactsModel>;
    operational_charges_array;
    slabs: FormGroup;
    tab1_response;
    selectedItem: any;
    locationPorts: any[] = [];
    storage_charge: any;
    currentDate = new Date(); // Variable to get current date
    // todayDate = new Date();
    // docDate = new Date();

    // dropdown variables
    dd_depotTypes: BackendListModel<DomainCode>;
    dd_billDepots: BackendListModel<DomainCode>;
    dd_approachableVia: BackendListModel<LocationConnectivityModel>;
    // dd_ports: BackendListModel<LocationModel>;
    dd_ports: BackendListModel<Locationport>;
    dd_container_size: BackendListModel<ContainerSize>;
    dd_depotDocumentsTypes: BackendListModel<DomainCode>;
    dd_depotFunction: BackendListModel<DomainCode>;
    dd_depotCurrency: BackendListModel<CurrencyModel>;
    dd_depotLocation: BackendListModel<LocationModel>;
    dd_getListOpeartionalCharge: BackendListModel<OperationalCharges>;
    dd_Location_ports: BackendListModel<Locationport>;
    dd_getLocationDocuments: BackendListModel<Locationdocuments>;
    dd_getListContainerCharges: BackendListModel<Charge>;
    dd_getListContainerTypeGroup: BackendListModel<Depotcontainertypegroup>;
    // storage_charge:BackendListModel<StorageCharge>;

    defaultSlab: Slab = {
        days: null,
        charge_rate: null
    }

    storage_slabs: Slab[] = [];

    //keys to Transform
    keysToTransformTab1;
    keysToTransformDocuments;
    keysToTransformPorts;
    keysToTransformManhourcharge;
    keysToTransformManhourchargeData;
    keysToTransformStoragecharge;
    keysToTransformOperationalCharge;
    transform_operationalcharge;

    // enableState = false;
    stateDisabled: boolean = true;
    stateUrl: string;
    depot_country_id:string;

    constructor(
        private formBuilder: FormBuilder,
        private domainService: DomainCodeApiService,
        private locationService: LocationApiService,
        private depotMasterService: DepotMasterApiService,
        private _snackBar: MatSnackBar,
        private currencyService: CurrencyMasterApiService,
        private http: HttpClient,
        private route: ActivatedRoute,
        @Inject(DOCUMENT) private document: Document,
        private datePipe: DatePipe,
        public dialog: MatDialog,
        private router: Router,
        private docService: DocumentApiService,
        public embassyService: EmbassyService
    ) {
    }

    _depotObject: any
    @Input()
    get depotObject() {
        return this._depotObject;
    }
    set depotObject(val) {
        if (val != null) {
            this._depotObject = val;
            this._contacts = val.contacts;
            this._documents = val.documents;
            if (val.man_hour_charge == null) {
                this.manhourchargeObject = { ... this.defaultManhourcharge };
            } else {
                this.manhourchargeObject = val.man_hour_charge;
            }
            if (val.location_ports == null && val.location_ports == undefined) {
                this.locationPorts.push({ ...this.defaultPort })
            }
            else {
                this.locationPorts = val.location_ports;
            }
            this._ListOpeartionalCharge = val.operational_charges;
        }
    }

    defaultDepot: DepotMasterTab1 = {
        id: null,
        name: null,
        location_type: 'depot',
        depot_owner_type: null,
        local_name: null,
        address: null,
        agreement_valid_date: null,
        location_billing_type: null,
        location_email: null,
        location_contact_no: null,
        working_hrs_from: null,
        working_hrs_to: null,
        week_offs: null,
        is_edi_available: false,
        edi_code: null,
        remarks: null,
        country: null,
        state: null,
        depot_week_offs: '',
        ports: [],
        connectivities: [],
        free_storage_days_upto_teus: null,
        is_active: true
    }

    @Input()
    documentObject: any;
    defaultDocument: Locationdocuments = {
        id: null,
        effective_from_date: null,
        effective_to_date: null,
        document: null,
        document_type: null,
        location: null
    }

    // portObject: any;
    defaultPort: Locationport = {
        id: null,
        name_display: null,
        updated_at: null,
        created_at: null,
        is_active: true,
        is_primary: true,
        location: null,
        port: null,
        distance_in_km: null
    }

    @Input()
    contactObject: any;
    defaultContact: ContactsModel = {
        id: null,
        first_name: null,
        last_name: null,
        profile: null,
        email: null,
        phone: null,
        enable_email_notification: null,
        address: null,
        function: null,
        location: null,
        is_active: true,
    }

    @Input()
    manhourchargeObject: any;
    defaultManhourcharge: ManHourCharge = {
        id: null,
        man_hour_charges: null,
        effective_from_date: null,
        effective_to_date: null,
        man_hour_charges_currency: null,
        depot: null
    }

    @Input()
    operationalChargeObject;
    defaultoperationalCharge: OperationalCharges = {
        id: null,
        is_active: true,
        charge_rate_currency: null,
        charge_rate: null,
        effective_from_date: null,
        effective_to_date: null,
        depot: null,
        charge: null,
        container_size: null,
        container_type_group: null
    }

    @Input()
    storagechargeObject;
    defaultStorageCharge: StorageCharge = {
        id: null,
        thereafter_charge_rate: null,
        currency: 'USD',
        slabs: [],
        effective_from_date: null,
        effective_to_date: null,
        charge_pulse: 2000,
        free_days: null,
        container_size: null
    }

    ngOnInit() {
        this.loggedInUser = JSON.parse(localStorage.getItem('current_user'));
        this.depotObject = { ...this.defaultDepot };
        this.contactObject = { ...this.defaultContact };
        this.documentObject = { ... this.defaultDocument };
        this.manhourchargeObject = { ... this.defaultManhourcharge };
        this.operationalChargeObject = { ...this.defaultoperationalCharge };
        this.storagechargeObject = { ... this.defaultStorageCharge };
        this.getInitialData();
        this.getContainerTypeGroup();
        this.getContainerCharges();
        this.getApproachableVia(null);

    }

    // Get Depot optional charges to bind in dropdown
    getDepotOptionalCharges(id) {
        this.depotMasterService.getOptionalDepotCharges(id).subscribe({
            next: response => {
                this.depotOptionalChargeList = response.results;
                this.loader = false;
            },
            error: error => {
                return this.catchError(error);
            }
        })
    }

    // Get Table columns and rows
    getOperationalChargeForTable(depot_id) {
        this.depotMasterService.getOperationalChargeTableStructure().subscribe({
            next: response => {
                this.operationalChargeTable = response;

                let typeGroupId = [...new Set(this.operationalChargeTable.depot_charges.map(elm => elm.container_type_group.id))];
                let sizeId = [...new Set(this.operationalChargeTable.depot_charges.map(elm => elm.container_size.id))];
                for (let i = 0; i < typeGroupId.length; i++) {
                    for (let j = 0; j < sizeId.length; j++) {
                        this.col_order.push(`${typeGroupId[i]}${sizeId[j]}`);
                        this.opChargeErrors.operational_charges[i][j] = { charge_rate: [] }
                    }
                }

                let data = [] // to create dynamic display columns
                for (let i = 0; i < this.operationalChargeTable.depot_charges.length; i++) {
                    data[i] = `${this.operationalChargeTable?.depot_charges[i]?.container_size?.size}_${this.operationalChargeTable?.depot_charges[i]?.container_type_group?.name}`
                }
                this.operationalChargeDisplayColumns = ['charge_name', ...data, 'charge_rate_currency', 'action']

                this.getOperationalChargeData(depot_id);
                this.getDepotOptionalCharges(depot_id)
            },
            error: error => {
                return error;
            }
        });
    }

    // GET Operational charge data
    getOperationalChargeData(id) {
        this.depotMasterService.getOperationalChargeDataByDepotId(id).subscribe({
            next: response => {
                for (let i = 0; i < response.results.length; i++) {
                    let charge_map = {}
                    let charge = [];
                    this.opChargeErrors.operational_charges[i] = [];
                    for (let j = 0; j < response.results[i].operational_charges.length; j++) {
                        let key = `${response.results[i].operational_charges[j].container_type_group}${response.results[i].operational_charges[j].container_size}`;
                        charge_map[key] = response.results[i].operational_charges[j];
                        this.opChargeErrors.operational_charges[i][j] = { charge_rate: [] }
                    }
                    for (let i of this.col_order) {
                        charge.push(charge_map[i])
                    }
                    response.results[i].operational_charges = [...charge]
                }
                this.operationalChargeData = new MatTableDataSource(response.results);

                // GET & bind currency of a row
                for (let i = 0; i < response.results.length; i++) {
                    this.opChargeCurrency[i] = response.results[i].operational_charges[0].charge_rate_currency
                }
            },
            error: error => {
                return error;
            }
        });
    }

    // Put operational charge
    putOperationalCharges(data, message) {
        this.depotMasterService.putOperationalcharge(data).subscribe({
            next: response => {
                this._snackBar.open(`Operational charge ${message}!`, 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
            },
            error: error => {
                return this.catchError(error);
            }
        })
    }

    // Post Operational charge
    postOperationalCharges(data) {
        this.depotMasterService.postOperationalcharge(data).subscribe({
            next: response => {
                this._snackBar.open("Operational charge added!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.isAddOpChargeDisabled = false
            },
            error: error => {
                return this.catchError(error);
            }
        })
    }

    // Function to enable editing the row
    editOpCharge(item) {
        item.isEdit = true;
    }

    opChargeErrors: any = {
        operational_charges: [
            [
                {
                    charge_rate: []
                },
                {
                    charge_rate: []
                }
            ],
            [
                {
                    charge_rate: []
                },
                {
                    charge_rate: []
                }
            ]
        ]
    };

    // Function to save operational charge
    saveOpCharge(item, index) {
        if (item.isEdit == true) {
            for (let i = 0; i < item.operational_charges.length; i++) {
                if (item.operational_charges[i].charge_rate != null) {
                    item.operational_charges[i].charge_rate_currency = this.opChargeCurrency[index];
                    if (item.operational_charges[i].id == null) {
                        this.postOperationalCharges(item.operational_charges[i]);
                    } else {
                        this.putOperationalCharges(item.operational_charges[i], "updated");
                    }
                    item.isEdit = false
                } else {
                    this.opChargeErrors.operational_charges[index][i] = { charge_rate: [] }
                    this.opChargeErrors.operational_charges[index][i].charge_rate = ['Charge required']
                    item.isEdit = true;
                    return;
                }
            }
            if (item.isEdit == false) {
                setTimeout(() => {
                    this.getOperationalChargeForTable(this.depotObject.id);
                    this.getDepotOptionalCharges(this.depotObject.id);
                    this.isAddOpChargeDisabled = false
                }, 2000);
            }
        }
    }

    // Function to remove operational charge
    removeCharge(item) {
        if (item.charge_type === "Depot Optional") {
            for (let i = 0; i < item.operational_charges.length; i++) {
                item.operational_charges[i].is_active = false;
                this.putOperationalCharges(item.operational_charges[i], "removed");
            }
            setTimeout(() => {
                this.getOperationalChargeForTable(this.depotObject.id);
            }, 1000);
        } else {
            this._snackBar.open(`${item.charge.charge_head} cannot be removed!`, 'Close', {
                verticalPosition: 'top',
                duration: 3000,
            });
        }
    }

    saveBasic() {
        // this.savedBasic=true;
        this.saveDepot();
        //for post both API at the one click of save button
        // this.locationPorts.forEach((item, index) => {
        //     this.onPortsSave(item, index);
        //   });
        // setTimeout(() => this.to(2), 1)
    }

    to(a: any) {
        document.getElementById("card" + a)?.scrollIntoView({ block: "center", behavior: "smooth" });
    }

    backToList() {
        // if (this.depotObject.location_ports?.length == '0') {
        //     this.openWarning('At least one port mapping is required.', '', 'I Understand');
        // }
        // else {
        this.refreshDepot.emit();
        this.back.emit();
        this.router.navigate([], {
            queryParams: {
                'id': null,
            },
            queryParamsHandling: 'merge'
        });
        setTimeout(() => {
            this.locationPorts =[]
            this.isEditable = true;
            // this.savedBasic = false;
            this.isDisabled = false;
            this.showEdi = false;
            this.depotObject = { ...this.defaultDepot };
            this.errorObj = {};
            this.locationPorts = [this.defaultPort];

            this.loader = false;
        }, 600);
        // }
    }

    openWeekend(check) {
        this.showWeekoff = !this.showWeekoff;
        if (check == this.depotObject.week_offs) {
            this.depotObject.week_offs = null;
        }
    }

    toggle(val) {
        this.editRowId = val;
    }

    openEdi(check) {
        this.showEdi = !this.showEdi;
        this.depotObject.edi_code = null;
    }

    openPrime(i) {
        document.getElementById(`prime${i}`)!.classList.toggle("visible");
    }

    edit(i) {
        document.getElementById(`fci${i}`)!.classList.add("flip");
        setTimeout(() => {
            document.getElementById(`fci${i}`)!.classList.add("hideFront");
        }, 600)
    }

    scrolltop() {
        document.getElementById("top")?.scrollIntoView({ block: "start", behavior: "smooth" });
    }

    editContact(contact) {
        this.contactObject = JSON.parse(JSON.stringify(contact));
    }

    openDD() {
        document.getElementById("mySidepanel")!.style.width = "493px";
    }

    closeDD() {
        this.isEditable = true;
        this.contactObject = { ...this.defaultContact };
        this.errorObj = {};
        document.getElementById("mySidepanel")!.style.width = "0";
    }

    expandToggle(event: any) {
        if (this.isToggler == false) {
            this.accordion.openAll();
            this.isToggler = true;
            event.target.classList.replace('flaticon-maximize', 'flaticon-minimize')
        } else if (this.isToggler == true) {
            this.accordion.closeAll();
            this.isToggler = false;
            event.target.classList.replace('flaticon-minimize', 'flaticon-maximize')
        }
    }

    complete() {
        this.saveBasic();
        document.getElementById("step3")!.innerHTML = "Completion";
        document.getElementById("i3")!.classList.replace('flaticon-commercials', 'flaticon-accept');
        this.isshowDoc = false;
        this.isshowCmplt = true;
    }

    saveUpload() {
        this.isshowDoc = false;
        this.isshowCmplt = true;
    }


    // Add new row of operational charge after selecting depot optional charge from dropdown
    addRow(item) {
        this.opChargeErrors.operational_charges.push([
            {
                charge_rate: []
            },
            {
                charge_rate: []
            }
        ]);

        let data = {
            charge: null,
            operational_charges: []
        };

        let keysToTransform = [
            'hsn_code',
            'uom',
            'charge_group',
            'receivable_payable',
            'charge_category'
        ];

        if (item != null) {
            for (const key of keysToTransform) {
                if (item[key] != null && item[key] != undefined) {
                    item[key] = item[key].id;
                }
            }

            for (let i = 0; i < this.operationalChargeTable.depot_charges.length; i++) {
                data['operational_charges'][i] = {
                    charge: item.id,
                    charge_rate: null,
                    charge_rate_currency: null,
                    container_size: this.operationalChargeTable.depot_charges[i].container_size.id,
                    container_type_group: this.operationalChargeTable.depot_charges[i].container_type_group.id,
                    depot: this.depotObject.id
                }
            }

            this.opChargeCurrency.push('USD')
            data['charge'] = { ...item };

            // List Change detection
            let new_list = [...this.operationalChargeData.data]
            new_list.push(data);
            this.operationalChargeData.data = new_list;

            this.isAddOpChargeDisabled = true;
            this.selectedDepotOptionalCharge = null;
        }
    }

    addSlabs(idx) {
        this.storage_charge[idx].slabs.push({ ...this.defaultSlab });
    }

    removevalue(i, j) {
        if (this.isEditable == true) {
            this.storage_charge[i].slabs.splice(j, 1);
        }
    }

    removeRow(id) {
        this._ListOpeartionalCharge = this._ListOpeartionalCharge.filter((res) => res.id !== id);

    }

    wasEdit() {
        this.isEditable = true;
        if (this.depotObject?.week_offs) {
            this.showWeekoff = true;
        }
        if (this.depotObject?.is_edi_available) {
            this.showEdi = true;
        }
        this.wasedit = true; //secondary condition to show button in isEditable
        // this.savedBasic = true;
        this.errorObj = {};
        this.isEditableChange.emit(true);
        this.operationalChargeData.data.forEach(charge => {
            charge.isEdit = true;
        });
    }
    cancelEdit() {
        this.isEditable = false;
        this.wasedit = false;
        this.showWeekoff = false;
        this.showEdi = false;
        this.isEditableChange.emit(false);

        this.operationalChargeData.data.forEach(charge => {
            charge.isEdit = false;
        });

        this.errorObj = {};
    }
    editDepot(element) {
        this.depotObject = JSON.parse(JSON.stringify(element));
        this.fromTimeFormat(element.working_hrs_from);
        this.toTimeFormat(element.working_hrs_to);
    }

    addDefaultPort() {
        this.locationPorts.push({ ... this.defaultPort });
        setTimeout(() => {
            this.edit(this.locationPorts.length - 1);
        }, 200)
    }

    Defaultport() {
        if (this.locationPorts.length == 0) {
            this.addDefaultPort();
        }
        else if (this.locationPorts[this.locationPorts.length - 1].port != null && this.locationPorts[this.locationPorts.length - 1].name_display != null) {
            this.addDefaultPort();
        }
        else {
            this._snackBar.open("You already have unfinished data of port-mapping. Complete that first to add the second mapping!", 'Close', {
                verticalPosition: 'top',
                duration: 3000,
            });
        }

    }

    getInitialData() {
        return forkJoin(
            this.getDepotTypes(),
            this.getBillDepot(),
            // this.getApproachableVia(null),
            this.getPorts(),
            this.getContainerSize(),
            this.getDepotDocumentsType(),
            this.getDepotFunctions(),
            this.getCurrencyType(),
        ).subscribe(() => {
            this.route.queryParams.subscribe(params => {
                if ('id' in params) {
                    this.getDepotbyID(params['id']);
                    this.isEditable = false;
                    this.depotObject.id = params['id'];
                }
            });
        })
    }

    // drop down fetch
    getDepotTypes() {
        return this.domainService.getByGroup('DepotOwnerType').pipe(
            map(response => {
                this.dd_depotTypes = response;
            }));
    }

    getBillDepot() {
        return this.domainService.getByGroup('DepotBillingCycle').pipe(
            map(response => {
                this.dd_billDepots = response;
            }));
    }

    getApproachableVia(id) {
        this.depotMasterService.getApproachableVia(id).subscribe(response => {
            this.dd_approachableVia = response;
            return response;
        })
    }

    // getPorts() {
    //     return this.locationService.getPortLocation().pipe(
    //         map(response => {
    //             this.dd_ports = response;
    //         }));
    // }
    getPorts() {
        return this.depotMasterService.getDepotPorts().pipe(
            map(response => {
                this.dd_ports = response;
            }));
    }
    getContainerSize() {
        return this.depotMasterService.getContainerSizeType().pipe(
            map(response => {
                this.dd_container_size = response;
            }));
    }

    getDepotDocumentsType() {
        return this.domainService.getByGroup('DepotCommunicationDocuments').pipe(
            map(response => {
                this.dd_depotDocumentsTypes = response;
            }));
    }

    getDepotFunctions() {
        return this.domainService.getByGroup('DepotFunctions').pipe(
            map(response => {
                this.dd_depotFunction = response;
            }));
    }

    getCurrencyType() {
        return this.currencyService.getAllCurrency().pipe(
            map(response => {
                this.dd_depotCurrency = response;
            }));
    }

    getDepotName() {
        return this.locationService.getDepotLocation().pipe(
            map(response => {
                this.dd_depotLocation = response;
            }));
    }

    getOperationalCharge() {
        this.depotMasterService.getOperationalcharge().subscribe(response => {
            this.dd_getListOpeartionalCharge = response;
        })
    }

    getContainerCharges() {
        this.depotMasterService.getContainerCharges().subscribe(response => {
            this.dd_getListContainerCharges = response;
        })
    }

    getContainerTypeGroup() {
        this.depotMasterService.getDepotContainerTypeGroup().subscribe(response => {
            this.dd_getListContainerTypeGroup = response;
        })
    }

    catchError(error) {
        if (error.status >= 500) {
            this.errorObj = { ...error.error };
            return error;
        } else if (error.status > 399 && error.status < 500) {
            this.errorObj = { ...error.error };
            return error;
        }
    }
    catchErrorPort(error) {
        if (error.status >= 500) {
            this.errorObj = { ...error.error };
            return error;
        } else if (error.status > 399 && error.status < 500) {
            this.errorObj = { ...error.error };
            return error;
        }
    }

    openWarningDialog(label: string, temp) {
        this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            data: { subTitle: ``, description: temp }
        })
    }

    //postData
    postDepotformTab1(data) {
        data['connectivities'] = this.getIdListFromObjList(data.connectivities);
        if (data['is_edi_available'] == true && data['edi_code'] == null || data['edi_code'] == "") {
            data['is_edi_available'] = false;
        }
        if (data['week_offs'] == null && this.showWeekoff == true) {
            this.openWarning('Select atleast one week off.', '', 'I Understand');
        }
        else {
            this.depotMasterService.depotCreateTab1(data).subscribe({
                next: (response: any) => {
                    this.savePortsAndGoNext();
                    // this.getCurrencyByCountryId(response.country?.id);
                    this.getDepotbyID(response.id);
                    this._snackBar.open("Depot created Successfully!", 'Close', {
                        verticalPosition: 'top',
                        duration: 2000,
                    });
                    // this.openWarning('At least one port mapping is required.', '', 'I Understand');
                    // this.savedBasic = true;
                    this.depotObject = response;
                    this.isDisabled = true;
                    return response;
                },
                error: error => {
                    return this.catchError(error);
                    this.isDisabled = false;

                }
            });
        }
        this.scrolltop();
    }

    updateDepotformTab1(id, data) {
        data['connectivities'] = this.getIdListFromObjList(data.connectivities);
        if (data['is_edi_available'] == true && data['edi_code'] == null || data['edi_code'] == "") {
            data['is_edi_available'] = false;
        }
        // if(data['week_offs']==true && data['week_offs']==null){
        //     data['week_offs']==false;
        // }
        // if (data.location_ports?.length == '0') {
        //     this.openWarning('At least one port mapping is required.', '', 'I Understand');
        // }
        // else 
        if (data['week_offs'] == null && this.showWeekoff == true) {
            this.openWarning('Select atleast one week off.', '', 'I Understand');

        }
        else {
            this.depotMasterService.updateDepotTab1(id, data).subscribe({
                next: (response: any) => {
                    this.savePortsAndGoNext();
                    this.getCurrencyByCountryId(response.country?.id);
                    this._snackBar.open("Depot updated Successfully!", 'Close', {
                        verticalPosition: 'top',
                        duration: 2000,
                    });
                    this.depotObject = response;
                    this.isDisabled = true;
                    return response;
                },
                error: error => {
                    return this.catchError(error);
                    this.isDisabled = false;

                }
            });
        }
        // if (data.week_offs) {
        //     this.isWeekoffs = true;
        // }
        this.scrolltop();
    }

    resetComponent() {
        this.errorObj = {};
        this.depotObject = { ...this.defaultDepot };
    }

    saveDepot() {
        this.keysToTransformTab1 = [
            'state',
            'country',
            'depot_owner_type',
            'location_billing_type',
            'logo'
        ];
        let payload = { ...this.depotObject };
        for (const key of this.keysToTransformTab1) {
            if (payload[key] != null && payload[key] != '')
                payload[key] = payload[key].id;
        }
        payload['location_type'] = "depot";
        payload['depot_id'] = this.depotObject.id;
        // payload['location_contact_no'].country =this.depotObject.country;
        if (payload.id != null) {
            this.updateDepotformTab1(payload.id, payload);
        } else {
            this.postDepotformTab1(payload);
        }
    }

    postContact(data) {
        data['location'] = this.depotObject.id;
        this.depotMasterService.postdepotCreateContacts(data).subscribe({
            next: response => {
                this._snackBar.open("Contact successfully updated.", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.getDepotbyID(this.depotObject.id);
                this.closeDD();
            }, error: error => {
                return this.catchError(error);
            }
        });
    }

    updateContact(data) {
        data['location'] = this.depotObject.id;
        this.depotMasterService.updatedepotContacts(data).subscribe({
            next: response => {
                this._snackBar.open("Contact successfully updated.", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.getDepotbyID(this.depotObject.id);
                this.closeDD();
            }, error: error => {
                return this.catchError(error);
            }
        });
    }

    //get ID from ObjectList
    getIdListFromObjList(objList: any[]) {
        let objIds = []
        for (let obj of objList) {
            objIds.push(obj.id);
        }
        return objIds;
    }

    postDocuments(data) {
        if (data['document'] !== null) {
            data['document'] = data['document'].id;
        }
        data['location'] = this.depotObject.id;
        this.depotMasterService.postLocationDocuments(data).subscribe({
            next: response => {
                this._snackBar.open("Post Documents Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.documentObject = { ... this.defaultDocument };
                this._documents.push(response);
                this.getDepotbyID(this.depotObject.id);
            },
            error: error => {
                return this.catchError(error);
            }
        });
    }

    editDocuments(element) {
        this.documentObject['document'] = { ...element?.document };
        this.documentObject['effective_from_date'] = element.effective_from_date;
        this.documentObject['effective_to_date'] = element.effective_to_date;
        this.documentObject['id'] = element.id;
    }

    updateDocuments(id, data) {
        data['document'] = data['document'].id;
        data['location'] = this.depotObject.id;
        this.depotMasterService.updateLocationDocuments(data, id).subscribe({
            next: response => {
                this._snackBar.open("Update Documents Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.documentObject = { ... this.defaultDocument };
                this._documents.push(response);
                this.getDepotbyID(this.depotObject.id);
            },
            error: error => {
                return this.catchError(error);
            }
        });
        // this.documentObject = { ...this.defaultDocument };
    }

    deleteDocuments(data) {
        this.loggedInUser = JSON.parse(localStorage.getItem('current_user'));
        if (data['document']?.created_by?.email == this.loggedInUser.email) {
            this.depotMasterService.deleteLocationDocuments(data.id).subscribe(response => {
                this._documents.push(response);
                this._snackBar.open("Successfully delete!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.getDepotbyID(this.depotObject.id);
            })
        }
        else {
            this._snackBar.open("You are not allowed to delete this File!", 'Close', {
                verticalPosition: 'top',
                duration: 2000,
            });
        }
    }

    saveDocuments() {
        let payload = { ...this.documentObject };
        if (payload.id != null) {
            this.updateDocuments(payload.id, payload);
        } else {
            this.postDocuments(payload);
        }
    }

    postManHourCharge(data) {
        this.depotMasterService.postdepotManHourcharge(data).subscribe({
            next: response => {
                this._snackBar.open("Successfully updated", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                // this.manhourchargeObject = { ... this.defaultManhourcharge };
            }, error: error => {
                return this.catchError(error);
            }
        })
    }

    updateManHourCharge(data) {
        this.depotMasterService.putdepotManHourcharge({ man_hour_charges: [data] }, this.depotObject.id).subscribe({
            next: response => {
                this._snackBar.open("Successfully updated!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
            }, error: error => {
                if (error.status >= 500) {
                    this.errorObj = { ...error.error.man_hour_charges[0] };
                    return error;
                } else if (error.status > 399 && error.status < 500) {
                    this.errorObj = { ...error.error.man_hour_charges[0] };
                    return error;
                }
                return error;
            }
        })
    }

    onSaveManHourCharge() {
        let payload = { ...this.manhourchargeObject };
        payload['depot'] = this.depotObject.id;
        if (payload.id != null) {
            this.updateManHourCharge(payload);
        } else {
            this.postManHourCharge(payload);
        }

    }


    postStorageCharges(data) {
        this.depotMasterService.postdepotStorageCharge(data, this.depotObject.id).subscribe({
            next: response => {
                this._snackBar.open("Successfully upload!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.storage_charge = response;
                this.getCurrencyByCountryId(this.depot_country_id);

                console.log("Storage Charge",this.storage_charge);
            },
            error: error => {
                return this.catchError(error);
            }
        })
    }

    // updateStorageCharges(data) {
    //     this.depotMasterService.updatedepotStorageCharge(data, this.depotObject.id).subscribe({
    //         next: response => {
    //             this._snackBar.open("Successfully upload!", 'Close', {
    //                 verticalPosition: 'top',
    //                 duration: 2000,
    //             });
    //             this._storagecharge = response;
    //         }, error: error => {
    //             return this.catchError(error);
    //         }
    //     })
    // }

    // onSaveStorageCharge(item) {
    //     let payload = { ...this.storage_charge };
    //     if (payload.id != null) {
    //         this.updateStorageCharges(item);
    //     } else {
    //         this.postStorageCharges(item);
    //     }
    // }

    // postOperationalCharge(element, index) {
    //     element['depot'] = this.depotObject.id;
    //     this.depotMasterService.postOperationalcharge(element).subscribe({
    // next: response => {
    //         this._snackBar.open("Successfully upload!", 'Close', {
    //             verticalPosition: 'top',
    //             duration: 2000,
    //         });
    //         this._ListOpeartionalCharge[index] = response;
    //         this._ListOpeartionalCharge.push(response);
    // }, error: error => {
    //     return this.catchError(error);
    // }
    //     })
    // }

    updateOperationalCharge(element, index) {
        this.keysToTransformOperationalCharge = [
            'container_size',
            'container_type_group',
            'charge',
        ];
        let payload = { ...element };
        for (const key of this.keysToTransformOperationalCharge) {
            if (element[key] != null && element[key] != '')
                element[key] = element[key].id;
        }
        element['depot'] = this.depotObject.id;
        this.depotMasterService.putOperationalcharge(element).subscribe({
            next: response => {
                this._snackBar.open("Successfully upload!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
            }, error: error => {
                return this.catchError(error);
            }
        })
    }

    getlocationPortMapping(id) {
        this.depotMasterService.getLocationportMapping(id).subscribe(response => {
            this._snackBar.open("Successfully upload!", 'Close', {
                verticalPosition: 'top',
                duration: 2000,
            });
        })
    }
    isSaved: boolean = false;

    postlocationPortMapping(data, index) {
        data['location'] = this.depotObject.id;
        this.depotMasterService.postLocationportMapping(data).subscribe({
            next: response => {
                // this.isSaved = true;
                this._snackBar.open("Port added Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.locationPorts[index] = response;

                this.errorObj = {}
            }, error: error => {
                document.getElementById(`fci${index}`)!.classList.add("hideFront");
                document.getElementById(`fci${index}`)!.classList.add("flip");
                this.locationPorts[index].errorObj = error.error;
                return this.catchErrorPort(error);
            }
        })
    }

    updatelocationPortMapping(data, index) {
        data['location'] = this.depotObject.id;
        if (data['port'] != null) {
            if (typeof data['port'] != 'string' && 'id' in data['port']) {
                data['port'] = data['port'].id;
            }
        }
        this.depotMasterService.updateLocationportMapping(data).subscribe({
            next: response => {
                // this.isSaved = true;
                this._snackBar.open("Port Update Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.locationPorts[index] = response;
                this.getDepotbyID(this.depotObject.id);
                this.errorObj = {}
            }, error: error => {
                document.getElementById(`fci${index}`)!.classList.add("hideFront");
                document.getElementById(`fci${index}`)!.classList.add("flip");
                this.locationPorts[index].errorObj = error.error;
                return this.catchErrorPort(error);
            }
        })
    }

    deleteOperationalCharge(element, index) {
        this.depotMasterService.deleteOperationalcharge(element.id).subscribe(response => {
            this.getOperationalCharge();
            this._snackBar.open("Successfully delete!", 'Close', {
                verticalPosition: 'top',
                duration: 2000,
            });
        })
    }

    editOperationalCharge(element, index) {
        element.isEdit = !element.isEdit;
        element = JSON.parse(JSON.stringify(element));
    }

    contactEdit() {
        this.isEditable = true;
        this.isEditableChange.emit(true);
        this.errorObj = {};
    }

    onContactSave() {
        let payload = { ... this.contactObject };
        if (payload.id != null) {
            this.updateContact(payload);
        } else {
            this.postContact(payload);
        }
    }

    onPortsSave(item, index) {
        document.getElementById(`fci${index}`)!.classList.remove("hideFront");
        document.getElementById(`fci${index}`)!.classList.remove("flip");
        if (this.isEditable == true) {

            if (item.is_active == false) { // Set primary port as false if is_active is false
                item.is_primary = false;
            }
            setTimeout(() => {
                if (item.id != null) {
                    this.updatelocationPortMapping(item, index);

                } else {
                    this.postlocationPortMapping(item, index);
                }
            }, 600)
        }
    }

    filterStatebyCountryID(data) {
        if (data !== null) {
            this.stateUrl = `${this.country_url}state/?name=::search::&country=${data.id}`;
            this.depotObject.state = null
            this.stateDisabled = false;
            // this.depotObject.location_contact_no.country = data;
        }
        if (data == null) {
            this.depotObject.state = null;
            this.stateUrl = null;
            this.stateDisabled = true;
        }
    }

    fromTimeFunc(time) {
        if (time == "" && time == undefined || this.depotObject.working_hrs_from == "") {
            this.depotObject.working_hrs_from = null;
        }
        else {
            this.depotObject.working_hrs_from = time;
        }
    }

    fromTimeFormat(time) {
        if (time != null) {
            this.depotObject.working_hrs_from = time.slice(0, -3)
        }
    }

    toTimeFunc(time) {
        if (time == "" && time == undefined || this.depotObject.working_hrs_to == "") {
            this.depotObject.working_hrs_to = null;
        }
        else {
            this.depotObject.working_hrs_to = time;
        }
    }

    toTimeFormat(time) {
        if (time != null) {
            this.depotObject.working_hrs_to = time.slice(0, -3)
        }
    }

    clearError(error) {
        this.defaultErrorObj = error;
    }

    editable(event) {
        this.isEditable = event;
    }

    getDepotbyID(id, ordering = '') {
        // this.savedBasic = true;
        this.depotMasterService.getDepotMasterbyID(id, ordering).subscribe(response => {
            this.depot_country_id = response.country?.id;
            this.fromTimeFormat(this.depotObject.working_hrs_from);
            this.toTimeFormat(this.depotObject.working_hrs_to);
            this.getDepotStoragechargebyDepotId(response.id);
            this.getOperationalChargeData(response.id);
            this.getOperationalChargeForTable(id);
            this.getApproachableVia(id);
            this._contacts = new MatTableDataSource(response['contacts']);
            this._documents = response['documents'];
            this.locationPorts = response['location_ports'];
            this.getCurrencyByCountryId(response.country?.id);

        })
    }

    getDepotStoragechargebyDepotId(id) {
        this.depotMasterService.getdepotStoragecharge(this.depotObject.id).subscribe(response => {
            this.storage_charge = response;
            // this.storage_charge['slabs'].reverse();
        })
    }

    getISDcodeandCurrencyByCountry(item) {
        if (!this.depotObject.id) {
            if (item == null) {
                this.depotObject.country = null;
                return;
            }
            let countryId = item.id
            let filteredCountry;
        }
    }

    refreshDepotList(pageSize = null, pageIndex = null, searchTerm = '') {
        pageSize = pageSize || this.pageSize;
        pageIndex = pageIndex || this.pageIndex
        this.locationService.getDepot(pageSize, pageIndex + 1, searchTerm).subscribe({
            next: response => {
                this.pageLength = response.count;
            }
        })
        this.router.navigateByUrl['master-data/depot-master/'];
    }

    getLocationDocumentsbyId(id, ordering = '') {
        // this.savedBasic = true;
        this.depotMasterService.getLocationDocumentsbyId(id, ordering).subscribe(response => {
        })
    }

    testReload() {
        this.router.navigate(['master-data/depot-master'])
            .then(() => {
                window.location.reload();
            });
    }

    testReload1() {
        this.testReload();
        setTimeout(() => {
            this.addNew.emit();
        }, 20);
    }

    editableToggle() {
        this.wasEdit();
    }
    toggleEditable() {
        if (this.isEditable) {
            this.cancelEdit();  // Disable edit mode
        } else {
            this.wasEdit();     // Enable edit mode
        }
    }
    clickedDocumentToDelete;
    deleteDocument(element) {
        this.clickedDocumentToDelete = element;
        this.openWarningDialogDelete("Are you sure delete this document?", "No", "Yes");
    }
    openWarningDialogDelete(label: string, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            data: { subTitle: label, parent: this, label1: action1, label2: action2, negativeAction: this.negativeResponse, positiveAction: this.positiveResponse }
        })
        dialogRef.afterClosed();
    }

    positiveResponse(parent) {
        parent.deleteDocuments(parent.clickedDocumentToDelete);
    }

    negativeResponse(parent) {
        parent.clickedDocumentToDelete = null;
        return;
    }

    //for Edit Depot
    clickedDepotToEdit;
    editDepotMaster(element) {
        this.clickedDepotToEdit = element;

        this.openWarningDialogEdit("Are you sure Edit this Depot?", "No", "Yes");
    }
    openWarningDialogEdit(label: string, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            data: { subTitle: label, parent: this, label1: action1, label2: action2, negativeAction: this.negativeResponseEdit, positiveAction: this.positiveResponseEdit }
        })
        dialogRef.afterClosed();
    }

    positiveResponseEdit(parent) {
        parent.editDepot(parent.clickedDepotToEdit);
    }

    negativeResponseEdit(parent) {
        parent.clickedDepotToEdit = null;
        return;
    }

    //for Edit Depot Type
    // depotType(element){
    //     if (this.isEditable == true) {
    //         this.editDepotType(element);
    //     }
    // }
    clickedDepottypeToEdit;
    editDepotType(element) {
        this.clickedDepottypeToEdit = element.value;
        this.openWarningDialogEditDepotType("You are trying to change the Depot Type. This might result in change in Reports and Analytics. Do you still want to continue?", "No", "Yes");
    }
    openWarningDialogEditDepotType(label: string, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            data: { subTitle: label, parent: this, label1: action1, label2: action2, negativeAction: this.negativeResponseEditDepotType, positiveAction: this.positiveResponseEditDepotType }
        })
        dialogRef.afterClosed();
    }

    positiveResponseEditDepotType(parent) {
        parent.clickedDepottypeToEdit = this.clickedDepottypeToEdit;
    }

    negativeResponseEditDepotType(parent) {
        parent.clickedDepottypeToEdit = this.depotObject.depot_owner_type;
        return;
    }
    openWarning(label: string, description, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, parent: this, description: description, label1: action1, label2: action2 }
        });
    }
    // changeDepotOwner(event) {
    //     if (event.dev_value == "supplier's_depot") {
    //         this.isShownPort = false;
    //     }
    //     else {
    //         this.isShownPort = true;
    //     }
    // }

    //sorting Documents
    announceSortChange(sortState: Sort) {
        switch (sortState.active) {
            case ' Effective From': {
                sortState.active = 'effective_from_date';
                break;
            }
            default:
                break;
        }

        switch (sortState.direction) {
            case 'asc':
                this.getDepotbyID(this.depotObject.id, `${sortState.active}`);
                break;

            case 'desc':
                this.getDepotbyID(this.depotObject.id, `-${sortState.active}`);
                break;

            default:
                this.getDepotbyID(this.depotObject.id);
        }
    }

    validate() {
        const nameRegex = /^[A-Za-z]{3,}$/;

        if (!this.depotObject.name) {
            this.errorObj.name = ['Depot Name is required.'];
        } else if (nameRegex.test(this.depotObject.name) == false) {
            this.errorObj.first_name = ['Depot Name should be minimum of 3 characters and should not contain any numbers and special characters'];
        }

        return Object.keys(this.errorObj).reduce((acc, key) => acc && this.errorObj[key].length === 0, true);

    }

    getCurrencyByCountryId(id) {
        this.depotMasterService.getCurrencybyCountryId(id).subscribe(currency => {
            if (currency.currencies.length) {
                this.globalCurrency = currency.currencies[0].currency_code;
                console.log("Depot currency fetch", currency);
                if (this.manhourchargeObject.man_hour_charges_currency == null) {
                    this.manhourchargeObject.man_hour_charges_currency = this.globalCurrency;
                }
                console.log(" this storage charge Checked by Bharati", this.storage_charge)
                this.storage_charge.forEach(charge => {
                    if (charge.currency == null) {
                        charge.currency = this.globalCurrency;
                    }
                });
                this.operationalChargeData?.data.forEach(charge => {
                    if (charge.charge_rate_currency == null) {
                        charge.charge_rate_currency = this.globalCurrency;
                    }
                });
            }
        })
    }

    savePortsAndGoNext() {
        this.locationPorts.forEach((item, index) => {
            this.onPortsSave(item, index);
        });
        setTimeout(() => this.to(2), 1);
    }
      
}

